import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { MachineType } from '../../../models/interfaces/machine-type';
import { Step } from '../../../models/interfaces/step';
import { HistorianService } from '../../../services/historian.service';

@Component({
  selector: 'app-card-last-change',
  templateUrl: './card-last-change.component.html',
  styleUrls: ['./card-last-change.component.scss'],
  standalone: false
})
export class CardLastChangeComponent implements OnChanges {

  @Input() load?: boolean;

  public lastChange: string = '';
  public sinceChange: number = 0;
  public sincePeriod:string = '';
  public cips: number = 0;


  constructor(private active: ActivatedRoute, private service: HistorianService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.load) return;

    this.active.params.subscribe(params => {
      const id = parseInt(params['id'])

      this.service.getMachineType(id).subscribe(m => this.loadData(m));
    });
  }

  private loadData(machine: MachineType): void {
    if (!machine) return;
    this.calculateCips(machine);
    this.calculateFields(machine)
  }

  private calculateFields(machine: MachineType): void {
    // Parse dates more reliably - ensure consistent timezone handling
    const lastChangeDate = new Date(machine.membranereplacement_last);
    const currentDate = new Date();

    //console.log('Machine replacement last: ');
    //console.log(lastChangeDate);
    // Reset time to start of day to get accurate day difference
    const lastChangeDateStart = new Date(lastChangeDate.getFullYear(), lastChangeDate.getMonth(), lastChangeDate.getDate());
    const currentDateStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

    // Calculate difference in milliseconds, then convert to days
    const timeDiff = currentDateStart.getTime() - lastChangeDateStart.getTime();
    const diffDays = Math.max(0, Math.floor(timeDiff / (1000 * 60 * 60 * 24)));

    // Calculate weeks properly
    const diffWeeks = Math.floor(diffDays / 7);

    this.lastChange = lastChangeDate.toLocaleDateString();
    this.sincePeriod = 'Weeks';
    if(diffDays<7)
        this.sincePeriod = 'Days';
    this.sinceChange = (diffDays < 7) ? diffDays : diffWeeks;
  }

  private calculateCips(machine: MachineType): void {
    let steps: Record<string, Step> = {};
    machine.steps.forEach((s: Step) => steps[s.order] = s);

    let count = 0;
    let index = 0;

    this.service.getSteps(this.service.fillRequest('UP01_Master_Sequence', machine.membranereplacement_last, new Date().toISOString())).subscribe(data => {
      while (index < data.length - 1) {
        const before = data[index];
        index++;

        if (steps[data[index].step]?.iscip_marker) {

        } else if (steps[before.step]?.isready_marker) {

          let start = new Date(before.timestart);
          while (index < data.length - 1 && !steps[data[index].step]?.isready_marker && !steps[data[index].step]?.iscip_marker && data[index].step > 3) { index++ }
          let end = new Date(data[index].timestart);

          count++;
        }
      }

      this.cips = count;
    })
  }

}
